<template>
  <div style="margin: 10px auto; text-align:center;">
    <el-avatar :size="60" :src="getAvatarUrl()"></el-avatar>
    <div style="margin-top: 10px; font-size: 16px">使用账号 <strong style="font-weight: bold">{{ user.userName }}</strong> 连接</div>
    <div style="margin: 30px 0 10px">
      <el-button type="primary" style="width: 100%" @click="btnApproveClick">授权使用</el-button>
    </div>
    <div style="margin: 10px 0">
      <el-button type="default" style="width: 100%" @click.prevent="btnSwitchClick">切换账号</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import api from '@/api/connect';
import { IUser } from '@/types/models';
import utils from '@/utils';
import { defineComponent } from 'vue';
import { PAGE_TYPE_AUTH, PAGE_TYPE_LOGIN } from '../pageType';

interface IState {
  user: IUser;
  token: string;
}

export default defineComponent({
  data() {
    return {
      user: {} as IUser,
      token: '',
    } as IState;
  },
  methods: {
    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    btnApproveClick() {
      window.parent.postMessage({
        userName: this.user.userName,
        token: this.token,
      }, '*');
    },

    btnSwitchClick() {
      this.$emit('redirect', PAGE_TYPE_LOGIN);
    },
  },
  mounted() {
    api.get((res) => {
      if (res.isAuthenticated && res.user && res.token) {
        this.user = res.user;
        this.token = res.token;
      } else {
        this.$emit('redirect', PAGE_TYPE_AUTH);
      }
    });
  },
});
</script>
